// Auto-generated by set-version.js
export const buildInfo = {
  version: '1.0.0',
  hash: 'TEMP-3YYU98',
  builtAt: '2026-10-30T18:30:36.350Z'
};
